import { SliceErrorState } from '../sliceError';

export interface GameHelpItem {
  show_card?: boolean;
  card_title?: Array<{ text: string }>;
  card_link?: { url: string };
  card_type?: string;
}

export const defaultCommonUIState = {
  depositLink: '',
  supportLink: '',
  depositLimitsLink: '',
  showGameWindow: false,
  showDepositButton: false,
  showExitButton: false,
  showSoundButton: false,
  showLogo: false,
  showResponsibleGaming: false,
  responsibleGamingLink: '',
  showBalance: false,
  balanceLink: '',
  customButtons: [] as Array<{ label: string; link: string; icon?: string }>,
  themeName: '',
  themeData: {},
  gameHelpItems: [] as GameHelpItem[],
};

export type CommonUiSlice = {
  commonUIContext: Partial<typeof defaultCommonUIState>;
  commonUIError: SliceErrorState;
  setCommonUIContext: (newState: Partial<typeof defaultCommonUIState>) => void;
  setCommonUIError: (newState: Partial<SliceErrorState>) => void;
  resetCommonUIContext: () => void;
};

export type CommonUIErrorPayload = Partial<SliceErrorState>;
export type CommonUIPayload = Partial<typeof defaultCommonUIState>;
